import { useRef, useState } from "react";
import { Upload, Loader2, Trash2, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import api, { formatApiError } from "../../lib/api";

// Uploads a single image to the media library and returns its URL via onChange(url).
export default function SingleImageUpload({ value = "", onChange, testid = "single-image" }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/media/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.webp_url || data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-4" data-testid={testid}>
      <div className="h-20 w-32 shrink-0 rounded-lg overflow-hidden border border-white/15 bg-black/30 grid place-items-center">
        {value ? <img src={value} alt="" className="h-full w-full object-cover" data-testid={`${testid}-preview`} /> : <ImageIcon className="h-6 w-6 text-white/25" />}
      </div>
      <div className="flex flex-col gap-2">
        <input ref={fileRef} type="file" accept="image/*" hidden onChange={onUpload} data-testid={`${testid}-input`} />
        <Button type="button" size="sm" disabled={uploading} onClick={() => fileRef.current?.click()} className="cf-gold-btn font-semibold gap-2" data-testid={`${testid}-btn`}>
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {value ? "Replace image" : "Upload image"}
        </Button>
        {value && (
          <button type="button" onClick={() => onChange("")} className="text-xs text-firered/80 hover:text-firered inline-flex items-center gap-1" data-testid={`${testid}-remove`}>
            <Trash2 className="h-3 w-3" /> Remove
          </button>
        )}
      </div>
    </div>
  );
}
